var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 70,
    viewBox: "0 0 113 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1216128604",
    filter: "url(#filter0_d_4462_31421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 100838",
    d: "M103.75 23.3925C103.75 23.3925 106.901 23.2373 108.116 23.8508C112.293 25.9595 112.293 41.0719 108.116 43.1806C106.901 43.794 104.286 43.1806 104.286 43.1806C104.286 43.1806 104.875 41.9668 105.25 40.2657C105.812 36.7168 105.626 31.6153 105.625 33.5293C105.624 35.0569 105.812 30.5293 105.25 27.3282C104.875 24.703 103.75 23.3925 103.75 23.3925Z",
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 100840",
    d: "M9.25 23.3925C9.25 23.3925 6.09936 23.2373 4.88407 23.8508C0.706546 25.9595 0.706546 41.0719 4.88407 43.1806C6.09936 43.794 8.71387 43.1806 8.71387 43.1806C8.71387 43.1806 8.125 41.9668 7.75 40.2657C7.1875 36.7168 7.37357 31.6153 7.375 33.5293C7.37614 35.0569 7.1875 30.5293 7.75 27.3282C8.12499 24.703 9.25 23.3925 9.25 23.3925Z",
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 100839",
    x: 7,
    y: 1.25,
    width: 99,
    height: 64.125,
    rx: 32.0625,
    fill: "#7636D9",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 100838_2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4462_31421)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 9.125,
    width: 83.625,
    height: 48.75,
    rx: 24.375,
    fill: "#F1EBFB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.6875,
    y: 9.3125,
    width: 83.25,
    height: 48.375,
    rx: 24.1875,
    stroke: "#7636D9",
    strokeWidth: 0.375
  })), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M29.5736 51.9232C29.6686 50.3273 31.3509 49.3368 32.7925 50.028L38.596 52.8108C40.2197 53.5894 40.3165 55.8649 38.7648 56.7785L32.579 60.4206C31.0273 61.3342 29.0845 60.1456 29.1914 58.3481L29.5736 51.9232Z",
    fill: "#F1EBFB"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2833",
    cx: 75.0625,
    cy: 30.6875,
    r: 7.3125,
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2835",
    cx: 38.3125,
    cy: 30.6875,
    r: 7.3125,
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 2834",
    d: "M65.125 38C65.125 39.1327 64.9116 40.2542 64.497 41.3006C64.0824 42.3471 63.4747 43.2979 62.7086 44.0988C61.9425 44.8997 61.0331 45.535 60.0321 45.9685C59.0312 46.4019 57.9584 46.625 56.875 46.625C55.7916 46.625 54.7188 46.4019 53.7179 45.9685C52.7169 45.535 51.8075 44.8997 51.0414 44.0988C50.2753 43.2979 49.6676 42.3471 49.253 41.3006C48.8384 40.2542 48.625 39.1327 48.625 38L56.875 38H65.125Z",
    fill: "#7636D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4462_31421",
    x: 0.25,
    y: 0.5,
    width: 112.5,
    height: 68.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4462_31421"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4462_31421",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4462_31421",
    x: 14.5,
    y: 9.125,
    width: 85.125,
    height: 50.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.5,
    dy: 4.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4462_31421"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/botIcon.52621f240459466d9920041da7563a03.svg";
export { ForwardRef as ReactComponent };